import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MyRadio = ({ label, customFunction, ...props }) => {
  const [field] = useField(props)

  return (
    <div className="flex items-center">
      <input
        className={
          'h-4 w-4 border-slate-300 bg-slate-100 text-primary focus:ring-2 focus:ring-primary ' +
          'dark:border-primary dark:bg-primary dark:ring-offset-primary dark:focus:ring-primary'
        }
        type="radio"
        {...field}
        {...props}
      />

      <label
        className="ml-2 text-sm font-medium text-slate-900 dark:text-slate-300"
        htmlFor={props.id || props.name}
        onClick={customFunction}
      >
        {label}
      </label>
    </div>
  )
}
export default MyRadio

MyRadio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  customFunction: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
}
